import React from 'react';
import { LargeHeading } from '@/components/Views/Heading';
import { NormalText } from '@/components/Views/Text';

const TeamWork = ({ component, id }) => {
    return (
        <section id={id} className='default-px default-py pb-0 font-Inter' style={{ paddingBottom: 0 }}>
            <LargeHeading heading='Teamwork makes the dream work!' className='lg:text-center mt-0' balanced={true} />
            <div className='default-max-w mx-auto flex flex-col lg:flex-row  items-center justify-center mt-8'>
                <div className='w-full lg:pr-5 xl:pr-14 flex lg:block justify-center lg:justify-end items-center '>
                    <div className='grid grid-cols-2 gap-6 gap-x-10'>
                        {component?.gallery?.map((item, index) => (
                            <div key={index} className='h-full max-w-[250px] lg:max-w-[310px]'>
                                <img
                                    width={item.customData?.width ?? '100%'}
                                    src={item?.url}
                                    alt={item?.alt ?? item.title}
                                    key={index}
                                    className={`h-full ${item?.title}`}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div className='w-full lg:pl-5 xl:pl-14 mt-10 lg:mt-0' id='left-border'>
                    <NormalText>
                        <span className='block'>
                            {/*                            <RichTextBlock
                                richText={component.richText}
                                style={{
                                    background: 'transparent',
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0
                                }}
                            />*/}
                        </span>
                    </NormalText>
                    <NormalText>
                        Muzology is honored to have received competitive R&D grants from the U.S. Department of Education and National Science Foundation. With
                        this generous support, Muzology continues to develop innovations in music-based learning.
                    </NormalText>
                    <NormalText>
                        Thank you to Great Schools Partnership and SONY Music for creative grants to produce our one-of-a-kind math music videos.
                    </NormalText>
                    <NormalText>
                        Muzology proudly serves on the “Math Power” Initiative Technical Advisory Board for mEducation Alliance, a non-governmental organization
                        focused on the evidence-driven and sustainable role of technology in education to advance quality educational outcomes.
                    </NormalText>
                </div>
            </div>
            <div className='mt-10'>
                <p className='text-2xl font-bold text-[#4B5563] text-center'>{component?.heading}</p>
                {/*
                <div className='default-max-w mx-auto block lg:hidden'>
                    <ul className='inline-block text-center '>
                        <li className=''>
                            <NormalText className=''>Top innovative start-up of 2018 (National School Boards Association)</NormalText>
                        </li>
                        <li>
                            <NormalText>Winner, 2020 Innovation Showcase (Software and Information Industry Association)</NormalText>
                        </li>
                        <li>
                            <NormalText>Winner, 2021 Emerging Company Competition (State Educational Technology Directors Association)</NormalText>
                        </li>
                        <li>
                            <NormalText>Finalist, 2021 Best Instructional Software Solution (CODiE Awards)</NormalText>
                        </li>
                        <li>
                            <NormalText>Top 10, global emerging education company globally in 2021 (GSV Cup)</NormalText>
                        </li>
                        <li>
                            <NormalText> Most promising education startup from North America in 2022 (HolonIQ)</NormalText>
                        </li>
                        <li>
                            <NormalText>Elite 200 global education technology company in 2023 (GSV Cup)</NormalText>
                        </li>
                    </ul>
                </div>
                */}
                {/*
                <div className='structured-text-wrapper text-center'>
                    <StructuredText data={component.data} />
                </div>
                */}
                <div className='block'>
                    {component?.infoItems.map((item, index) => (
                        <div key={index} className='flex justify-start lg:justify-center items-baseline min-h-[36px]'>
                            <div className='flex flex-row items-center'>
                                <div className='flex-shrink-0 flex-grow-0 h-2 w-2 rounded-full bg-[#4B5563] mr-3 translate-y-[-2px]' />
                                <p className='hidden lg:block my-0 font-normal text-[18px] leading-[28px] text-[#4B5563] '>{item.header}</p>
                                <NormalText className='lg:hidden text-[#4B5563] my-2 w-auto 2xl:text-[18px] xl:text-[18px]'>{item?.header}</NormalText>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <style jsx>{`
                #left-border {
                    border-left: none;
                    @media (min-width: 1024px) {
                        border-left: 1px solid #4b5563;
                        border-top: none;
                    }
                }
            `}</style>
        </section>
    );
};

export default TeamWork;
